import React from "react";
import { Card, CardHeader, CardBody, CardFooter, CardTitle } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import FormRow from "../../components/Row/FormRow";
import SelectRow from "../../components/Select/SelectRow";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import strings from "../../core/translate";

const CustomerUserForm = ({
  user,
  citylist,
  changeInput,
  handleValidSubmit,
  loading,
  CardStyle,
}) => {
  return (
    <AvForm
      onValidSubmit={handleValidSubmit}
      className="form-horizontal"
      id="TypeValidation"
    >
      <Card style={CardStyle}>
        <CardHeader>
          <CardTitle tag="h4">{strings.information}</CardTitle>
        </CardHeader>
        <CardBody>
          <FormRow
            label={strings.firstname}
            name="firstName"
            data={user.firstName}
            changeInput={changeInput}
          />
          <FormRow
            label={strings.lastname}
            name="lastName"
            data={user.lastName}
            changeInput={changeInput}
          />
          <FormRow
            label={strings.email}
            name="email"
            data={user.email}
            changeInput={changeInput}
          />
          <FormRow
            label={strings.phone}
            name="phoneNumber"
            data={user.phoneNumber}
            changeInput={changeInput}
          />
          <SelectRow
            label={strings.city}
            name="cityId"
            value={citylist?.find((city) => city.value === user.cityId) || {}}
            data={citylist}
            changeInput={changeInput}
          />
        </CardBody>
        <CardFooter className="text-center">
          <ButtonLoader color="primary" loading={loading}>
            {strings.save}
          </ButtonLoader>
        </CardFooter>
      </Card>
    </AvForm>
  );
};

export default CustomerUserForm;
